export const isInIframe = () => {
  try {
    if (typeof window !== 'undefined') {
      // MCP preview: mirror the server's isInIframe()=false via __INITIAL_MCP_FORCE_SSR__ — see MCP_PREVIEW.md#hydration-parity.
      if ((window as Window & { __INITIAL_MCP_FORCE_SSR__?: boolean }).__INITIAL_MCP_FORCE_SSR__) {
        return false;
      }
      return window.self !== window.top;
    }
  } catch (e) {
    // Reading window.top across a cross-origin boundary can throw a SecurityError; treat that as not-framed.
  }

  return false;
};
